import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { InputInfoToolTip } from 'src/components/Input/InputInfoToolTip';
import { AutoCloseField } from 'src/pages/ControlDeskPage/ProjectControls/ProjectSettingsModal/AutoCloseField';
import type { Project } from 'src/services/projectsService';
import { splitAutocloseWindow } from 'src/utils/autocloseWindow';

// The chat and Zoho integrations' advanced settings: auto-closing inactive conversations.
export const EditAutocloseAdvancedSettings = ({ currentProject }: { currentProject?: Project }) => {
  const { control, watch, resetField } = useFormContext();
  const isAutocloseEnabled = watch('autocloseEnabled');
  const { autocloseHours, autocloseMinutes } = splitAutocloseWindow(
    currentProject?.autoclose_time_window_minutes,
  );

  useEffect(() => {
    resetField('autocloseHours', {
      defaultValue:
        isAutocloseEnabled && currentProject?.autoclose_time_window_minutes ? autocloseHours : 0,
    });
    resetField('autocloseMinutes', {
      defaultValue:
        isAutocloseEnabled && currentProject?.autoclose_time_window_minutes ? autocloseMinutes : 0,
    });
  }, [isAutocloseEnabled]);

  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      <AutoCloseField
        control={control}
        label={
          <div className={'flex flex-row items-center gap-2.5'}>
            Auto-close on inactivity{' '}
            <InputInfoToolTip
              contentClassName={'max-w-[350px]'}
              infoToolTip={{
                description:
                  'Automatically mark conversations as resolved when customers have not responded within the set time.',
                side: 'right',
              }}
            />
          </div>
        }
        toggleName={'autocloseEnabled'}
        limitHourName={'autocloseHours'}
        limitMinuteName={'autocloseMinutes'}
        disabled={!isAutocloseEnabled}
      />
    </div>
  );
};
